export const getContentCheckoutCollectionList = (type, id) => state =>
  state.checkoutCollection.groupList[type]?.[id] || {};

export const getContentMainCheckoutCollection = (type, contentId) => state =>
  state.checkoutCollection.main[type]?.[contentId] || {};

export const getCheckoutCollectionById = collectionId => state =>
  state.checkoutCollection.byId[collectionId];

export const getCheckoutCollectionContentListById = collectionId => state =>
  state.checkoutCollection.contentList[collectionId];

export const getBundleOptionListById = collectionId => state =>
  state.checkoutCollection.bundleOptionList[collectionId];
